import { useState } from "react";
import useSaveReview from "../../hooks/useSaveReview";
import "./SendReviewScreen.css";

export default function SendReviewScreen() {
    
    const { saveReview } = useSaveReview();

    const [name, setName] = useState("");
    const [role, setRole] = useState("");
    const [location, setLocation] = useState("");
    const [text, setText] = useState("");
    const [rating, setRating] = useState(0);
    const [saving, setSaving] = useState(false);

    const handleSubmit = async () => {
        if (!name || !role || !location || !text || !rating) {
            alert("Please fill all fields and choose a rating");
            return;
        }

        try {
            setSaving(true);
            await saveReview({ name, role, location, text, rating });

            alert("Review submitted successfully!");

            setName("");
            setRole("");
            setLocation("");
            setText("");
            setRating(0);

        } catch (e) {
            alert("Error submitting review");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="review-page">
            <h1 className="review-title">Send Your Review</h1>
            <p className="review-subtitle">Your feedback helps us improve!</p>

            <div className="review-card">

                {/* NAME */}
                <div className="form-row">
                    <label className="form-label">Your Name</label>
                    <input
                        type="text"
                        className="form-input"
                        placeholder="Enter your full name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>

                {/* ROLE */}
                <div className="form-row">
                    <label className="form-label">Your Role</label>
                    <input
                        type="text"
                        className="form-input"
                        placeholder="Example: Android Developer"
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                    />
                </div>

                {/* LOCATION */}
                <div className="form-row">
                    <label className="form-label">Location</label>
                    <input
                        type="text"
                        className="form-input"
                        placeholder="Example: Noida / Bangalore / Pune"
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                    />
                </div>

                {/* RATING */}
                <div className="form-row">
                    <label className="form-label">Rating</label>

                    <div className="stars-container">
                        {[1, 2, 3, 4, 5].map((i) => (
                            <span
                                key={i}
                                className={`star ${i <= rating ? "active" : ""}`}
                                onClick={() => setRating(i)}
                            >
                                ★
                            </span>
                        ))}
                    </div>
                </div>

                {/* REVIEW TEXT */}
                <div className="form-row">
                    <label className="form-label">Your Review</label>
                    <textarea
                        className="form-textarea"
                        placeholder="Write your detailed review here..."
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                    />
                </div>

                {/* SUBMIT */}
                <button className="submit-btn" onClick={handleSubmit} disabled={saving}>
                    {saving ? "Submitting..." : "Submit Review →"}
                </button>
            </div>
        </div>
    );
}
